
    import Vue from "vue";
    import ContributionPeriod from "@/models/api/contributionPeriod/ContributionPeriod";
    import VuetifyFormMethods from "@/models/vuetify-form-methods";
    import { AxiosError } from "axios";
    import { SnackbarService } from '../../services/SnackbarService';
    import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
    import { ContributionPeriodService } from '../../services/ContributionPeriodService';
    import { DataTableHelper } from '@/helpers/DataTableHelper';
    import FakeInput from '@/components/ui/FakeInput.vue';

    export default Vue.extend({
        components: {
            DeleteDialog,
            FakeInput,
        },
        data() {
            return {
                pageHeader: this.$vuetify.lang.t('$vuetify.contributionPeriod.contributionPeriods'),
                items: new Array<ContributionPeriod>(),

                tableHeaders: [
                    {
                        text: "name", value: "name", sortable: false
                    },
                    {
                        text: "dateFrom", value: "startDate", sortable: false
                    },
                    {
                        text: "dateTo", value: "endDate", sortable: false
                    },
                    {
                        text: "contributionPeriod.lastRegistrationDate", value: "lastRegistrationDate", sortable: false
                    },
                    {
                        text: "", value: "actions", sortable: false
                    },
                ],
                isTableLoading: false,
                showDateEdit: false,
                editDialogOpen: false,
                editItem: new ContributionPeriod("","", "", null),
                registerFormValid: false,

                showDeleteDialog: false,
                itemToDeleteId: "",
                itemToDeleteName: ""
            };
        },
        created() {
            DataTableHelper.adaptTableHeaders(this.tableHeaders, this);
            this.getAll();
        },
        watch: {
            editDialogOpen: {
                handler(open: boolean) {

                    if (!open) {
                        (this.$refs.editForm as VuetifyFormMethods).reset();
                    }
                },
            },
        },
        methods: {
            prepareEdit(item: ContributionPeriod): void {
                // Use object assign in order to separate the modified item with existing item.
                // Keeps row in datatable the same, whilst updating the values.
                Object.assign(this.editItem, item);
            },
            async save(item: ContributionPeriod) {
                ContributionPeriodService.SaveContributionPeriod(item).then(
                    (result) => {
                        this.getAll();
                        this.editDialogOpen = false;                       
                        SnackbarService.addSuccessMessage(result?.data);
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
            async remove(id: number) {
                this.showDeleteDialog = false;

                if (id != null) {
                    ContributionPeriodService.RemoveContributionPeriod(id).then(
                        (result) => {
                            SnackbarService.addSuccessMessage(result?.data);
                            this.getAll();
                        },
                        (error: AxiosError) => {
                            SnackbarService.addErrorMessage(error.response?.data || error.response?.statusText
                            );
                        }
                    );
                }
            },
            async getAll() {
                this.isTableLoading = true;
                this.items = (await ContributionPeriodService.GetContributionPeriods()).data;
                this.isTableLoading = false;
                
            },
        },
    })


